import styled from 'styled-components';

export const _Error = styled.p`
  font-family: ${(props) => props.theme.fontFamilyPrimary};
  font-size: 16px;
  color: ${(props) => props.theme.red};
  margin-top: 0;
  margin-bottom: 1em;
  display: block;
  box-sizing: border-box;
`;
